import { useRouter } from 'next/router';
import { isTestnet } from '../featureFlags';

export const useCanonicalUrl = () => {
  const router = useRouter();

  const baseUrl = (
    isTestnet ? process.env.NEXT_PUBLIC_TESTNET_URL : process.env.NEXT_PUBLIC_MAINNET_URL
  ) as string;

  if (!baseUrl) return undefined;

  const canonicalUrl = new URL(router.asPath, baseUrl);

  return canonicalUrl.toString();
};
